<template>
  <div class="flex flex-col h-screen ext-shell text-gray-900">
    <ClientTopBar :active-id="PATIENTS_TAB" :nav-items="navItems" @change="onTabChange" />
    <div class="flex-1 overflow-auto ext-page">
      <div class="py-6 px-16">
        <div class="flex items-center gap-2 mb-4">
          <button
            class="flex items-center gap-1.5 text-[12px] text-gray-500 hover:text-gray-800 transition-colors"
            @click="$router.back()"
          >
            <font-awesome-icon :icon="['fas', 'arrow-left']" class="w-3 h-3" />
            Back
          </button>
        </div>
        <div class="bg-white rounded-lg border border-gray-100 shadow-sm overflow-hidden">
          <Overview_Patient :patient-identifier="patientIdentifier" :key="patientIdentifier" />
        </div>

      </div>
    </div>
    <ClientFooter />
  </div>
</template>

<script>
import ClientTopBar from './ClientTopBar.vue'
import ClientFooter from './ClientFooter.vue'
import Overview_Patient from '@/components/Overview/Overview_Patient.vue'
import { PATIENTS_TAB, fetchPortalTabs, portalNavItems } from '@/utils/externalPortal'

export default {
  name: 'ExternalPatientDetail',
  components: { ClientTopBar, ClientFooter, Overview_Patient },
  props: {
    patientIdentifier: { type: String, required: true },
  },
  data() {
    return { tabs: [], PATIENTS_TAB }
  },
  computed: {
    navItems() {
      return portalNavItems(this.tabs)
    },
  },
  async mounted() {
    try {
      this.tabs = await fetchPortalTabs()
    } catch {
      this.tabs = []
    }
  },
  methods: {
    onTabChange(id) {
      const entityId = this.$store.state.entity.current_entity_id
      this.$router.push({ name: 'ExternalEntity', params: { entityid: entityId }, query: { tab: id } })
    },
  },
}
</script>
